module.exports = __webpack_public_path__ + "media/images/components/map-icons/contacts-map-pin-other_category-b8418bf1a9138ab032c3160b7fd379c4.png";